import axios from "axios";
import { constant } from "../store/constant";

const { path } = constant;

class DataService {
  constructor() {
    axios.defaults.withCredentials = true; // Enable sending and receiving cookies
    
    axios.interceptors.response.use((response) => {
      console.log("response",JSON.stringify(response));
      console.log("Response Headers:", response.headers); // Log the response headers for debugging

      const cookies = response.headers["set-cookie"];
      if (cookies) {
        cookies.forEach((cookie) => {
          const [cookieName, cookieValue] = cookie.split(";")[0].split("="); // Extract cookie name and value
          document.cookie = `${cookieName.trim()}=${cookieValue.trim()}; path=/;`; // Set the cookie in the browser
        });
        console.log("Received cookies:", cookies);
      }

      return response;
    });
  }


  post(arg, endpoint, rejectWithValue) {
    const authDetail = localStorage.getItem("authorization");
    if (authDetail) {
      const token = JSON.parse(authDetail).token;
      axios.defaults.headers.common["Authorization"] = token;
      // withCredentials=true;
      // axios.defaults.withCredentials = true;
      // axios.defaults.withCredentials= true;
    }

    return axios
      .post(endpoint, arg)
      .then(({ data }) => {
        console.log("data",data);
        if (
          endpoint === path + "admin/auth/v1/login" ||
          endpoint === path + "client/auth/v1/login" ||
          endpoint === path + "client/auth/v1/verify-mfa"
        ) {
          if (data.code === 200 && data?.data?.token) {
            localStorage.setItem("authorization", JSON.stringify(data?.data));
            axios.defaults.headers.common["Authorization"] = data?.data?.token;
            console.log("data",axios.defaults.headers);
            // withCredentials=true;
          }
        }
        return data;
      })
      .catch((error) => {
        const { data } = error.response;
        if (data.code === 502 || data.code === 403) {
          return rejectWithValue(
            "Something went wrong, please refresh or try again"
          );
        } else if (data.code === 500 && data === "jwt expired") {
          localStorage.removeItem("authorization");
          window.location.replace("/");
        }
        return rejectWithValue(error.response.data);
      });
  }

  get(arg, endpoint, rejectWithValue) {
    const authDetail = localStorage.getItem("authorization");
    if (authDetail) {
      const token = JSON.parse(authDetail).token;
      axios.defaults.headers.common["Authorization"] = token;
      // axios.defaults.withCredentials = true;
    }
    return axios
      .get(endpoint, { params: arg })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        const { data } = error.response;
        if (data.code === 502 || data.code === 403) {
          return rejectWithValue(
            "Something went wrong, please refresh or try again"
          );
        } else if (data.code === 500 || data.code === 401) {
          localStorage.removeItem("authorization");
          window.location.replace("/login");
        }

        return rejectWithValue(error.response.data);
      });
  }

  delete(arg, endpoint, rejectWithValue) {
    const authDetail = localStorage.getItem("authorization");
    if (authDetail) {
      const token = JSON.parse(authDetail).token;
      axios.defaults.headers.common["Authorization"] = token;
      // axios.defaults.withCredentials = true;
    }
    return axios
      .delete(endpoint, { data: arg })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        const { data } = error.response;
        if (data.code === 502 || data.code === 403) {
          return rejectWithValue(
            "Something went wrong, please refresh or try again"
          );
        } else if (data.code === 500 || data.code === 401) {
          localStorage.removeItem("authorization");
          window.location.replace("/login");
        }

        return rejectWithValue(error.response.data);
      });
  }
}
export default new DataService();
